<div class="container-fluid py-3 px-4 left-menu-space" id="divMainContainer">
  <div class="page-title-box d-sm-flex justify-content-between bd-highlight">
    <h4 class="mb-0 f-bold-dubai text-secondary pb-3">Search</h4>
    <div class="page-title-right pb-3">
      <a class="btn btn-secondary btn-sm text-white" routerLink="/dashboard"><i class="fa fa-arrow-left"></i> Back</a>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="filter-section mb-3">
        <div class="card rounded pb-2 pt-3 mb-3 px-3">
          <div class="px-2">
            <div class="row">
              <div class="col-md-3">
                <div class="row">
                  <label class="col-sm-4 pr-2 py-2">Search</label>
                  <input type="search" class="form-control pl-4 col-sm-8" [(ngModel)]="searchText" placeholder="Search" (keyup.enter)="getSearchList(true);">
                  <div class="position-absolute position-top-8 position-right-5"><i class="la la-search"></i></div>
                </div>
              </div>
              <div class="col-md-3" *ngIf="actionType != 'Active Users'">
                <div class="row">
                  <label class="col-sm-4 pr-2 py-2">Start Date</label>
                  <input type="date" class="form-control col-sm-8" name="startDate" [(ngModel)]="model.startDate" placeholder="Date">
                </div>
              </div>
              <div class="col-md-3" *ngIf="actionType != 'Active Users'">
                <div class="row">
                  <label class="col-sm-4 pr-2 py-2">End Date</label>
                  <input type="date" class="form-control col-sm-8" name="endDate" [(ngModel)]="model.endDate" placeholder="Date">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-check form-check-inline px-3">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" [value]="2" [(ngModel)]="checkBoxVal" (click)="TypeCheckBoxSelection(2)" id="inlineRadio1" value="option1">
                  <label class="form-check-label" for="inlineRadio1">Attendance</label>
                </div>
                <div class="form-check form-check-inline px-3">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" [value]="1" [(ngModel)]="checkBoxVal" (click)="TypeCheckBoxSelection(1)" id="inlineRadio2" value="option2">
                  <label class="form-check-label" for="inlineRadio2">Meeting</label>
                </div>
                <div class="form-check form-check-inline px-3">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" [value]="4" [(ngModel)]="checkBoxVal" (click)="TypeCheckBoxSelection(4)" id="inlineRadio3" value="option2">
                  <label class="form-check-label" for="inlineRadio2">Active Users</label>
                </div>
              </div>
              <div class="col-lg-1 px-0">
                <button class="btn btn-dark btn-block mt-1" (click)="getSearchList(true);"><i class="la la-search fa-lg pr-1"></i>Search</button>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>

  <div id="loaderBg" class="card rounded pt-2 h-100">
    <div class="loader-bg" *ngIf="isLoader"></div>
    <div *ngIf="data==null ||data.length<=0 && !isLoader" class="border px-3 py-4 text-center rounded text-secondary">
      <!--<img src="{{noDataImage}}" alt="No Data" />-->
      <h5 class="pb-4 pt-2">No Data Available</h5>
    </div>
    <div *ngIf="actionType != 'Active Users'">
      <div class="pt-2 px-3 pb-3 border-bottom" *ngFor="let item of data">
        <h6 class="card-title d-inline f-bold-dubai">{{item.divisionName}}</h6>
        <div class="card-controls float-md-right float-sm-right">
        </div>
        <div class="text-success py-1">{{item.recordCount}}</div>
      </div>
    </div>
    <div *ngIf="actionType == 'Active Users'">
      <div class="pt-2 px-3 pb-3 border-bottom" *ngFor="let item of data">
        <img [src]="item.picture" alt="profile" class="wh-30 rounded-circle mr-2" />
        <h6 class="card-title d-inline f-bold-dubai">{{item.userName}}</h6>

        <div class="text-success py-1">{{item.divisionName}}</div>
        <div class="p-0">
          <span class="pr-2"> {{item.firstName}} {{item.lastName}}</span> |  <span class="px-2">{{item.emailId}}</span> | <span class="px-2"><b class="text-secondary">{{item.prNumber}}</b></span>
        </div>
      </div>
    </div>
  </div>
</div>
